import { jsx as _jsx } from "react/jsx-runtime";
import { TabGroup as HeadlessTabGroup } from '@headlessui/react';
export const TabGroup = ({ selectedIndex, onChange, children }) => {
    return (_jsx(HeadlessTabGroup, { selectedIndex: selectedIndex, onChange: onChange, children: children }));
};
